export enum FilterTypes {
  BOOLEAN = 'boolean',
  CHECKBOX = 'checkbox',
  COMPANIES = 'companies',
  DATE_RANGE = 'date',
  DECIMAL_RANGE = 'decimal',
  DEGREES = 'degrees',
  DOUBLE_SELECT = 'double_select',
  EDUCATIONS_YEAR_FROM = 'educations_year_from',
  EDUCATIONS_YEAR_TO = 'educations_year_to',
  FIELD_OF_STUDIES = 'field_of_studies',
  FREE_TEXT = 'free_text',
  FULLTEXT_SELECT = 'fulltext_select',
  INDUSTRIES = 'industries',
  KEYWORD = 'keyword',
  LOCATION = 'location',
  NATIONALITIES = 'nationalities',
  NUMBER_RANGE = 'number',
  SCHOOLS = 'schools',
  SELECT = 'select',
  SELECT_WITH_SEARCH_AND_OTHER_OPTIONS = 'select_with_search_and_other_options',
  SKILLS = 'skills',
  SUB_NETWORKS = 'sub_networks',
  YEAR_RANGE = 'range_year',
}
